export const UNREALIZED_PROFIT_THOUSAND_HUNDRED_PERCENT = 100;
